<template>
  <view class="radio-group-demo">
    <view class="cube-radio-group-example">
      <cube-radio-group
        options="{{ options }}"
        wx:model="{{ checkedValue }}"
        wx:model-prop="value"
      ></cube-radio-group>
    </view>
    <view bindtap="test">click me</view>
    <view class="view-desc">selected value: {{ checkedValue }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data: {
      options: [
        {
          value: 'Option1',
          text: 'Option1'
        },
        {
          value: 'Option2',
          text: 'Option2'
        }
      ],
      checkedValue: 'Option2'
    },
    methods: {
      test() {
        this.checkedValue = 'Option1'
      }
    }
  })
</script>

<style lang="stylus">
.radio-group-demo
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "view-desc": "../../components/desc/index",
    "cube-radio-group": "@mpxjs/mpx-cube-ui/src/components/radio-group/index"
  }
}
</script>
